import { Heading, LearnMoreLink, Text } from '@ui/themed';
import type { PropsWithChildren } from 'react';

export function SettingsSection({
  title,
  description,
  learnMoreUrl,
  children,
}: PropsWithChildren<{
  title: string;
  description?: string;
  learnMoreUrl?: string;
}>) {
  return (
    <section className="flex flex-col gap-3">
      <div>
        <Heading level="h3" style="sm">
          {title}
        </Heading>
        {(description || learnMoreUrl) && (
          <Text size="sm" variant="secondary">
            {description}
            {learnMoreUrl && (
              <>
                {' '}
                <LearnMoreLink link={learnMoreUrl} />
              </>
            )}
          </Text>
        )}
      </div>
      <div className="flex flex-col gap-4">{children}</div>
    </section>
  );
}
